export default __webpack_public_path__ + "static/media/water-6.4b5bf508.png";